module.exports = __webpack_public_path__ + "img/phone.dd1d95c7.svg";